var sika = sika || {};
( function () {
    sika.favorites = {
        cartData: null,
        init: function () {
            if ( jQuery( '.js-sika-shoefinder' ).length ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    //e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-favorites-list' );
                    sika.favorites.bindEvents();

                    if ( sessionStorage.getItem( 'sika.shoefinder.tempOrderline' ) !== null ) {
                        sika.favorites.rebuildCart();
                    }
                    sika.favorites.getList( null, sika.favorites.cartHandler.test );

                } );
            }

        },
        bindEvents: function () {
            jQuery( document ).on( 'click', '.js-sika-add-to-favorites-list', function ( event ) {
                event.preventDefault();
                var prodID = jQuery( this ).data( 'product-id' ),
                    variantId = jQuery( this ).data( 'variant-id' );
                var jForm = jQuery( '#sheet-' + prodID ).find( '.js-e-product-form' );
                if ( prodID === 'get' ) {
                    prodID = e4.util.hash.get( 'product' );
                    jForm = jQuery( '#sheet-' + prodID ).find( '.js-e-product-form' );
                }
                var postData = {
                    CartCmd: jForm.find( '.js-sika-products-item-input[data-name="CartCmd"]' ).data( 'value' ),
                    ProductID: jForm.find( '.js-sika-products-item-input[data-name="ProductID"]' ).data( 'value' ),
                    VariantID: jForm.find( '.js-sika-products-item-input[data-name="VariantID"]' ).data( 'value' ),
                    UnitID: jForm.find( '.js-sika-products-item-input[data-name="UnitID"]' ).data( 'value' ),
                    Redirect: jForm.find( '.js-sika-products-item-input[data-name="Redirect"]' ).data( 'value' ),
                    Quantity: jForm.find( '.js-sika-products-item-input[data-name="Quantity"]' ).data( 'value' )
                };
                sika.productsheet.getPDFdata( prodID, variantId, sika.productsheet.addSelection );
                sika.shoefinder.loader.show();
                sika.favorites.data( postData );
            } );
            jQuery( document ).on( 'click', '.js-sika-shoefinder-add-all-to-list', function ( event ) {
                event.preventDefault();
                var postData = {
                    CartCmd: 'addmulti',
                    Redirect: false
                };
                jQuery( '.sika-productlist-item' ).each( function ( index ) {
                    if ( jQuery( this ).is( '.in-cart' ) === false ) {
                        if ( index.toString().length === 1 ) {
                            index = '0' + index
                        }
                        postData[ 'ProductID' + index ] = jQuery( this ).find( '.js-sika-products-item-input[data-name="ProductID"]' ).data( 'value' );
                        postData[ 'ProductLoopCounter' + index ] = index;
                        postData[ 'Quantity' + index ] = 1;
                        postData[ 'VariantID' + index ] = jQuery( this ).find( '.js-sika-products-item-input[data-name="VariantID"]' ).data( 'value' );
                        sika.productsheet.getPDFdata( jQuery( this ).find( '.js-sika-products-item-input[data-name="ProductID"]' ).data( 'value' ), sika.productsheet.addSelection );
                    }
                } );
                sika.shoefinder.loader.show();
                sika.favorites.data( postData );
            } );
            jQuery( document ).on( 'click', '.js-sika-favorites-view-list', function ( event ) {
                event.preventDefault();
                sika.favorites.getList( null, sika.favorites.cartHandler.list );
            } );
            jQuery( document ).on( 'click', '.js-sika-favorites-download-list', function ( event ) {
                event.preventDefault();
                var jLocalItems = Object.keys( sessionStorage );
                var jLocalConvertedItems = sika.productsheet.convertLocalItems( jLocalItems );
                sika.shoefinder.loader.show();
                sika.productsheet.getScripts( 'list', jLocalConvertedItems );
            } );
            jQuery( document ).on( 'click', '.js-sika-favorites-delete-form-list', function ( event ) {
                event.preventDefault();
                sika.favorites.deleteFormListByElement( this );
            } );
            jQuery( document ).on( 'submit', '.js-mail-my-list-form', function () {
                var strFeedbackStore = jQuery( '.sika-shoefinder-renderFeedback' ).text();
                jQuery( '.js-shoefinder-feedback-string' ).val( strFeedbackStore );
                var jLocalAllItems = Object.keys( sessionStorage ),
                    arrSaveOrderlines = [];
                for ( var i = 0; i < jLocalAllItems.length; i++ ) {
                    if ( jLocalAllItems[ i ].indexOf( 'sika.pdfgen' ) > -1 ) {
                        var jsonProductPDF = JSON.parse( sessionStorage.getItem( jLocalAllItems[ i ] ) ).product;
                        //console.log( jsonProductPDF )
                        arrSaveOrderlines.push( jsonProductPDF.id + '|' + jsonProductPDF.variantID );
                    }
                }
                sessionStorage.setItem( 'sika.shoefinder.tempOrderline', arrSaveOrderlines );
                //console.log( 'setSessionStorage', arrSaveOrderlines )
                sika.shoefinder.loader.show();
            } );
            jQuery( document ).on( 'click', '.js-sika-shoefinder-clear-all-productpage', function ( event ) {
                event.preventDefault();
                sika.favorites.emptyCart( sika.favorites.cartData.cart.orderlines, true );

            } );
            var jLocalAllItems = Object.keys( sessionStorage );
            //console.log( 'jLocalAllItems', jLocalAllItems )
            if ( jLocalAllItems.length > 0 ) {
                var jLocalConvertedItems = sika.productsheet.convertLocalItems( jLocalAllItems );

                for ( var i = 0; i < jLocalConvertedItems.length; i++ ) {
                    var jLocalItem = JSON.parse( sessionStorage.getItem( 'sika.pdfgen.' + sika.productsheet.context + '.item.' + jLocalConvertedItems[ i ] ) );
                    jQuery( '.js-e-productlist' ).find( '.js-sika-productsheet-list-add[value="' + jLocalConvertedItems[ i ] + '"]' ).prop( 'checked', true );
                    if ( jLocalItem.pdf.ProductIcons !== undefined ) {
                        jQuery( '#pdf-sheet-' + jLocalConvertedItems[ i ] ).find( '.sika-pdf-feature-icons' ).html( '' );
                        jQuery( '#pdf-sheet-' + jLocalConvertedItems[ i ] ).find( '.sika-pdf-feature-icons' ).addClass( 'is-ready' );
                    }
                }
                jQuery( '.js-create-datasheet' ).prop( 'checked', true );
                jQuery( '.js-sika-productsheet-generate' ).show();
                jQuery( '.js-e-productlist' ).find( '.js-sika-productsheet-list-add-wrap' ).show();
            }
            jQuery( document ).on( 'hidden.bs.modal', '#sika-mail-my-list-modal', function () {
                if ( jQuery( '.js-sika-favorites-modal ' ).is( '.show' ) === true ) {
                    jQuery( 'body' ).addClass( 'modal-open' );
                }
            } );
        },
        success: function ( thankYoyText ) {
            jQuery( '.js-shoefinder-action-confirm-content-text' ).html( thankYoyText );
            var isloadedInterval = setInterval( function () {
                if ( sika.shoefinder.isLoaded === true ) {
                    clearInterval( isloadedInterval );
                    jQuery( '.shoefinder-action-confirm' ).addClass( 'open' ).animate( {
                        opacity: 1
                    }, 300 );
                    setTimeout( function () {
                        jQuery( '.shoefinder-action-confirm' ).animate( {
                            opacity: 0
                        }, 300, function () {
                            jQuery( this ).removeClass( 'open' );
                        } );
                        e4.util.hash.remove( 'mylist' );
                    }, 3000 );
                }
            }, 100 );
        },
        data: function ( postData ) {

            if ( postData === undefined ) {
                postData = {};
            }
            postData.OrderContext = 'SHOEFINDER';

            var jXhr = jQuery.ajax( {
                type: 'POST',
                url: e4.settings.ecom.cart.url,
                data: postData
            } );
            jQuery.when( jXhr ).done( function ( data ) {
                //console.log( postData, data )
                sika.favorites.cartData = data;
                sika.favorites.updateList( data );
                sika.shoefinder.loader.hide();
            } ).fail( function ( error ) {
                console.error( error );
            } );
        },
        rebuildCart: function () {
            var tempOrderlinesArr = sessionStorage.getItem( 'sika.shoefinder.tempOrderline' ).split( ',' );
            var postData = {
                CartCmd: 'addmulti',
                Redirect: false,
                OrderContext: 'SHOEFINDER'
            };
            for ( var i = 0; i < tempOrderlinesArr.length; i++ ) {
                var arrOrderline = tempOrderlinesArr[ i ].split( '|' );
                //console.log('arrOrderline', arrOrderline);
                postData[ 'ProductID' + ( i + 1 ) ] = arrOrderline[ 0 ];
                postData[ 'Quantity' + ( i + 1 ) ] = 1;
                postData[ 'VariantID' + ( i + 1 ) ] = arrOrderline[ 1 ];
                postData[ 'ProductLoopCounter' + ( i + 1 ) ] = +( i + 1 );

            }
            sika.favorites.data( postData );
            sessionStorage.removeItem( 'sika.shoefinder.tempOrderline' );
            if ( jQuery( '.js-sika-mail-my-list-modal' ).length === 0 ) {
                var jXhr = jQuery.ajax( {
                    url: '/data/mailmylist',
                    type: 'POST',
                    dataType: 'html',
                    data: {
                        OrderContext: postData.OrderContext
                    }
                } );
                jQuery.when( jXhr ).done( function ( html ) {
                    jQuery( '.js-sika-shoefinder' ).parent().append( html );
                } );

            }
        },
        getList: function ( intManualQuantity, callback ) {
            var jXhr = jQuery.ajax( {
                url: e4.settings.ecom.cart.url,
                type: 'GET',
                data: {
                    OrderContext: 'SHOEFINDER'
                }
            } );
            jQuery.when( jXhr ).done( function ( data ) {

                if ( callback !== undefined && typeof callback === 'function' ) {

                    callback( intManualQuantity, data );
                }

            } ).fail( function ( error ) {
                console.error( error );
            } );
        },
        cartHandler: {
            list: function ( intManualQuantity, data ) {
                jQuery( '.js-sika-favorites-container' ).html( e4.handlebars.tmpl.favoritesList( data ) );
                sika.favorites.updateList( data );
                if ( intManualQuantity !== 0 ) {
                    if ( data.cart.totalProductQuantity > 0 ) {
                        jQuery( '.js-sika-favorites-modal' ).modal( 'show' );
                    }
                    else {
                        jQuery( '.js-sika-favorites-modal' ).modal( 'hide' );
                    }
                }
            },
            test: function ( intManualQuantity, data ) {
                var jLocalAllItems = Object.keys( sessionStorage );
                if ( data.cart.totalProductQuantity > 0 && jLocalAllItems.length > 0 ) {
                    jQuery( '.js-sika-favorites-container' ).html( e4.handlebars.tmpl.favoritesList( data ) );
                    sika.favorites.updateList( data );

                }
                else if ( jLocalAllItems.length === 0 && data.cart.totalProductQuantity > 0 ) {
                    sika.favorites.emptyCart( true );
                }
                else if ( data.cart.totalProductQuantity === 0 && jLocalAllItems.length > 0 ) {
                    for ( var i = 0; i < jLocalAllItems.length; i++ ) {
                        if ( jLocalAllItems[ i ].indexOf( 'sika.pdfgen.' + sika.productsheet.context + '.item.' ) > -1 ) {
                            sessionStorage.removeItem( jLocalAllItems[ i ] );
                        }
                    }
                }
                if ( jLocalAllItems.length > 0 ) {
                    var jLocalConvertedItems = sika.productsheet.convertLocalItems( jLocalAllItems );
                    for ( var i = 0; i < jLocalConvertedItems.length; i++ ) {
                        var jLocalItem = JSON.parse( sessionStorage.getItem( 'sika.pdfgen.' + sika.productsheet.context + '.item.' + jLocalConvertedItems[ i ] ) );

                    }
                }
            }
        },
        updateList: function ( data ) {
            if ( data === undefined ) {
                data = sika.favorites.cartData;
            }
            if ( data !== null ) {
                var orderlines = data.cart.orderlines,
                    inCartArr = [];
                if ( orderlines.length === 0 ) {
                    jQuery( '.js-sika-favorites-view-list, .js-sika-favorites-mail-list, .js-sika-favorites-download-list' ).addClass( 'disabled' );
                }
                else {
                    jQuery( '.js-sika-favorites-view-list, .js-sika-favorites-mail-list, .js-sika-favorites-download-list' ).removeClass( 'disabled' );
                }
                jQuery( '.js-sika-shoefinder-productlist-cta' ).find( '.js-sika-favorites-view-list-count' ).text( orderlines.length );
                for ( var i = 0; i < orderlines.length; i++ ) {
                    inCartArr.push( orderlines[ i ].product.id + '-' + orderlines[ i ].product.colorId );
                }
                var waitForProducts = setInterval( function () {
                    if ( jQuery( '.js-sika-shoefinder-productlist-step' ).find( '.sika-productlist-item' ).length ) {
                        clearInterval( waitForProducts );
                        jQuery( '.js-sika-shoefinder-productlist-step' ).find( '.sika-productlist-item' ).each( function () {
                            var item = jQuery( this ).find( '.js-sika-add-to-favorites-list' ),
                                prodID = item.data( 'product-id' ) === 'get' ? e4.util.hash.get( 'product' ) : item.data( 'product-id' );

                            if ( jQuery.inArray( prodID, inCartArr ) !== -1 ) {
                                item.addClass( 'in-cart' );
                                item.closest( '.sika-productlist-item' ).addClass( 'in-cart' );

                            }
                            else {
                                item.removeClass( 'in-cart' );
                                item.closest( '.sika-productlist-item' ).removeClass( 'in-cart' );
                            }
                        } );
                    }
                }, 200 );
                if ( e4.util.hash.get( 'product' ) !== undefined ) {
                    var innerAddBtn = jQuery( '.js-shoefinder-productdetails-show.js-sika-favorites-action.js-sika-add-to-favorites-list.js-sika-products-item-input' );
                    if ( jQuery.inArray( e4.util.hash.get( 'product' ), inCartArr ) !== -1 ) {
                        innerAddBtn.text( innerAddBtn.data( 'added-text' ) );
                    }
                    else {
                        innerAddBtn.text( innerAddBtn.data( 'not-added-text' ) );
                    }
                }
            }
        },
        deleteFormListByElement: function ( domElm ) {
            jQuery( domElm ).find( '.clear-icon' ).hide();
            jQuery( domElm ).find( '.mini-loader' ).addClass( 'loading' );
            sessionStorage.removeItem( 'sika.pdfgen.' + sika.productsheet.context + '.item.' + jQuery( domElm ).data( 'product-id' ) );
            var jXhr = jQuery.ajax( {
                url: e4.settings.ecom.cart.url,
                type: 'POST',
                data: {
                    key: jQuery( domElm ).closest( '.js-e-orderline' ).attr( 'id' ),
                    CartCmd: 'delorderline',
                    OrderContext: 'SHOEFINDER'
                }
            } );
            jQuery.when( jXhr ).done( function ( data ) {

                sika.favorites.getList( null, sika.favorites.cartHandler.list );
            } ).fail( function ( error ) {
                console.error( error );
            } );
        },
        emptyCart: function ( stayOnProductpage ) {
            sika.shoefinder.loader.show();
            var jLocalAllItems = Object.keys( sessionStorage );
            for ( var i = 0; i < jLocalAllItems.length; i++ ) {
                if ( jLocalAllItems[ i ].indexOf( 'sika.pdfgen.' + sika.productsheet.context + '.item.' ) > -1 ) {
                    sessionStorage.removeItem( jLocalAllItems[ i ] );
                }
            }

            var jXhr = jQuery.ajax( {
                url: e4.settings.ecom.cart.url,
                type: 'POST',
                data: {
                    CartCmd: 'emptycart',
                    OrderContext: 'SHOEFINDER'
                }
            } );
            jQuery.when( jXhr ).done( function () {
                if ( stayOnProductpage === false ) {
                    e4.util.hash.remove( 'question' );
                    e4.util.hash.remove( 'productlist' );
                    e4.util.hash.remove( 'product' );
                    sika.shoefinder.steps.clear();
                    location.reload();
                }
                else {
                    location.reload();
                }

            } ).fail( function ( error ) {
                console.error( error );
            } );
        }
    };
}() );

